<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Examen Físico</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="examenfisico in datosPaginados" :key="examenfisico.idExamenFisico">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(examenfisico.idExamenFisico)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(examenfisico.idExamenFisico)" title="Editar">edit_square</i></td>
          <td>{{examenfisico.nombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteExamenFisico(examenfisico.idExamenFisico)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idExamenFisico" class="form-label">IdExamenFisico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamenFisico" name="idExamenFisico" v-model="datoExamenFisico.idExamenFisico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamenFisico.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoExamenFisico.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamenFisico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamenFisico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      examenfisicos : [],
      datoExamenFisico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.examenfisicos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwexamenfisicos/nombre/'+this.nombreBusqueda).then(response=>{
          this.examenfisicos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.examenfisicos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwexamenfisicos').then(response=>{
      this.examenfisicos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.examenfisicos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'codigo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'codigo'
      ];
      return validarForm(this.datoExamenFisico, requiredFields, requiredFieldsText);
    },
    async guardarExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ExamenFisico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ExamenFisico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoExamenFisico={}
      this.titulo   = 'Crear Examen Físico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idExamenFisico){
      this.modalWindow = true
      if(idExamenFisico != null){    
           api.get('/vwexamenfisicos/'+idExamenFisico).then(resp=>{
          this.datoExamenFisico = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Examen Físico'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idExamenFisico){
      if(idExamenFisico != null){
        this.$router.push('/examenfisicomd/'+idExamenFisico)
      }
    },
    async deleteExamenFisico (idExamenFisico) {
      try{
        await api.delete('/examenfisicos/'+idExamenFisico)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
